import styled, { css } from 'styled-components';

const getTextColor = palette => {
  return palette.type === 'light'
    ? 'rgba(0, 0, 0, 0.87)'
    : palette.common.white;
};

// prettier-ignore
export const HubspotFormWrapper = styled.div`
  font-family: ${(props) => props.theme.fonts.headingFamily};

  .hs-datepicker {
    font-family: ${(props) => props.theme.fonts.headingFamily}!important;

    .is-selected .pika-button {
      background: ${(props) => props.theme.palette.primary.main};
      box-shadow: none;
    }
    .is-today .pika-button {
      color: ${(props) => props.theme.palette.primary.main};
    }

    .pika-button:hover {
      color: #fff !important;
      background: ${(props) => props.theme.palette.grey[500]}!important;
    }
  }

  .submitted-message {
    text-align: center;
    color: ${(props) => props.theme.palette.text.primary};
    padding: ${(props) => (props.inline ? '6px' : '10px')};

    p {
      margin: 0;
    }
  }

  .hs-form {
    color: ${(props) => getTextColor(props.theme.palette)};
    ${(props) =>
      props.inline &&
      css`
        display: flex;
        align-items: flex-start;

        .hs-form-field {
          flex-grow: 1;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          padding-right: 18px;
        }

        .hs_error_rollup {
          display: none;
        }
      `}

    ${(props) =>
      props.hideRecaptcha &&
      css`
        .grecaptcha-badge {
          visibility: hidden;
          height: 0 !important;
        } /* https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed */
      `}
  }

  .cookie-reset-container {
    color: ${(props) => getTextColor(props.theme.palette)};
    a {
      color: ${(props) => getTextColor(props.theme.palette)};
    }
  }
  .inputs-list li label a {
    color: ${(props) => getTextColor(props.theme.palette)};
  }

  .hs-error-msgs {
    margin: 0;
    padding: 0;
    list-style-type: none;

    li {
      color: ${(props) => props.theme.palette.error.main};
    }
  }
  .hs-form-field {
    margin-top: 16px;
    margin-bottom: 8px;
  }
  .hs-field-desc,
  .hs-error-msgs li {
    margin: 0;
    font-size: 0.75rem;
    text-align: left;
    margin-top: 8px;
    min-height: 1em;
    line-height: 1em;
  }
  .hs-form-field > label {
    color: ${(props) => props.theme.palette.text.secondary};
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
  }

  input[type='text'],
  input[type='password'],
  input[type='datetime'],
  input[type='datetime-local'],
  input[type='date'],
  input[type='month'],
  input[type='time'],
  input[type='week'],
  input[type='number'],
  input[type='email'],
  input[type='url'],
  input[type='search'],
  input[type='tel'],
  input[type='color'],
  input[type='file'],
  textarea,
  select {
    width: 100% !important;
    appearance: none;
    font: inherit;
    padding: ${(props) => props.theme.spacing.unit - 2}px 0 ${(props) => props.theme.spacing.unit - 1}px;
    border: 0;
    box-sizing: content-box;
    vertical-align: middle;
    background-color: transparent;
    margin: 0 0 1px 0;
    webkittaphighlightcolor: transparent;
    display: block;
    min-width: 0;
    border-radius: 0;
    display: inline-flex;
    position: relative;
    font-family: ${(props) => props.theme.fonts.headingFamily};
    color: ${(props) => getTextColor(props.theme.palette)};
    font-size: ${(props) => (props.size === 'large' ? '1.5em' : '16px')};
    line-height: 1.1875em;

    border-bottom: 1px solid ${(props) => (props.theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)')};

    &:focus {
      outline: 0;
      margin-bottom: 0;
      border-bottom: 2px solid ${(props) => props.theme.palette.primary[props.theme.palette.type === 'light' ? 'dark' : 'light']};
    }

    &:hover:not(:focus) {
      margin-bottom: 0;
      border-bottom: 2px solid ${(props) => props.theme.palette.text.primary};
    }

    &.error,
    &.invalid {
      margin-bottom: 0;
      border-bottom: 2px solid ${(props) => props.theme.palette.error.main};

      &:hover:not(:focus) {
        border-bottom-color: ${(props) => props.theme.palette.error.main};
      }
    }

    &::placeholder {
      color: ${(props) => (props.theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.5)')};
    }
  }
  input[type='file'] {
    font-size: 14px;
  }
  ul.inputs-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;

    li.hs-form-checkbox,
    li.hs-form-radio {
      width: 100%;
    }
  }
  input {
    &[type='checkbox'],
    &[type='radio'] {
      margin: 0;
      padding: 0;
      outline: 0;
      appearance: none;
      border-radius: 0;
      border: none;
      background-color: transparent;
      display: inline-block;
      width: 48px !important;
      height: 36px;
      background-position: 50% 50%;
      background-repeat: no-repeat;
    }
  }

  .hs-button.primary {
    width: ${(props) => (props.buttonAlign ? 'auto' : '100%')};
    float: ${(props) => props.buttonAlign || 'none'};
    appearance: none;
    outline: 0;
    border: none;
    cursor: pointer;
    line-height: 1.4em;
    box-sizing: border-box;
    min-width: ${(props) => props.theme.spacing.unit * 11}px;
    min-height: ${(props) => (props.size === 'large' ? '50px' : '36px')};
    padding: ${(props) => props.theme.spacing.unit}px ${(props) => props.theme.spacing.unit * 2}px;
    border-radius: 5px;
    font-family: ${(props) => props.theme.fonts.headingFamily};
    font-weight: 700;
    font-size: ${(props) => (props.size === 'large' ? '18px' : '0.875rem')};
    transition: ${(props) =>
      props.theme.transitions.create(['background-color', 'box-shadow'], {
        duration: props.theme.transitions.duration.short,
      })};
    color: ${(props) => (props.buttonColor === 'white' ? props.theme.palette.grey[900] : props.theme.palette.primary.contrastText)};
    background-color: ${(props) => (props.buttonColor === 'white' ? 'white' : props.theme.palette.primary.main)};
    box-shadow: ${(props) => props.theme.shadows[2]};
    &:focus: {
      outline: 0;
      box-shadow: ${(props) => props.theme.shadows[6]};
    }
    &:active: {
      box-shadow: ${(props) => props.theme.shadows[8]};
    }
    &:hover: {
      background-color: ${(props) => props.theme.palette.primary.dark};
    }
  }
  .hs-form-checkbox-display,
  .hs-form-radio-display,
  .hs-form-booleancheckbox-display {
    color: ${(props) => getTextColor(props.theme.palette)};
    display: flex;
    align-items: center;
    margin-top: 4px;

    input[type='checkbox'],
    input[type='radio'] {
      margin-left: -12px;
      flex-shrink: 0;
    }

    > span {
      margin-left: 0 !important;
    }
  }
  .hs_error_rollup {
    margin-bottom: 8px;
  }
  .hs-form-required {
    display: none;
  }

  fieldset {
    max-width: 100% !important;
  }

  select {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill-opacity='65%' fill='${(props) => (props.theme.palette.type === 'light' ? 'black' : 'white')}' %3e%3cpath d='M7 10l5 5 5-5z' %3e%3c/path%3e%3c/svg%3e");
    background-position: 100% 50%;
    background-repeat: no-repeat;

    option {
      color: rgba(0, 0, 0, 0.87);
    }
  }

  input[type='checkbox'] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill-opacity='65%' fill='${(props) => (props.theme.palette.type === 'light' ? 'black' : 'white')}' %3e%3cpath d='M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' %3e%3c/path%3e%3c/svg%3e");
    &:checked {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill='${(props) => (props.theme.palette.type === 'light' ? 'black' : 'white')}' %3e%3cpath d='M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' %3e%3c/path%3e%3c/svg%3e");
    }
  }
  input[type='radio'] {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill-opacity='65%' fill='${(props) => (props.theme.palette.type === 'light' ? 'black' : 'white')}' %3e%3cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'%3e%3c/path%3e%3c/svg%3e");
    &:checked {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill='${(props) => (props.theme.palette.type === 'light' ? 'black' : 'white')}' %3e%3cpath d='M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'%3e%3c/path%3e%3c/svg%3e");
    }
  }

`;
